import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useMediaQuery } from 'react-responsive';
import cx from 'classnames';
import useAddToHomeScreen from 'hooks/useAddToHomeScreen';
import { checkIsIOS, checkIsInStandaloneMode } from 'helpers/platform';
import { ReactComponent as XIcon } from 'assets/img/x.svg';
import { ReactComponent as IOSMenuIcon } from 'assets/img/ios-menu.svg';

import s from './AddToHomeScreen.module.scss';

function AddToHomeScreen() {
  const isLaptop = useMediaQuery({ query: '(min-width: 1024px)' });

  const [show, setShow] = useState<boolean>(false);
  const [canShow, setPromptCanShow] = useState<boolean>(false);

  const portal = document.getElementById('add-to-home-screen-portal');

  const { prompt, promptToInstall } = useAddToHomeScreen();

  const canInstallApp = !!prompt;
  const isIOS = checkIsIOS();
  const isInStandaloneMode = checkIsInStandaloneMode();
  const canShowModal = canShow && (canInstallApp || (isIOS && !isInStandaloneMode));

  const handleClose = () => setShow(false);
  const handleInstall = () => {
    promptToInstall();
    handleClose();
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = document.documentElement.scrollTop;
      const availHeight = window.screen?.availHeight || 0;

      if (scrollPosition >= availHeight) setPromptCanShow(true);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (canShowModal) setShow(true);
  }, [canShowModal]);

  const homePageName = () => {
    if (isLaptop) return 'рабочий стол';
    return 'домашний экран';
  };

  const serviceName = 'Кулинария';
  const installAppText = `Добавить ярлык «${serviceName}» на ${homePageName()}?`;

  const imgSrc = `${process.env.PUBLIC_URL}/img/icon-192x192.png`;

  const installAppModalEl = (
    <div
      className={cx(s.AddToHomeScreenWrap, s.AddToHomeScreenWrap_InstallApp)}
      onClick={handleInstall}
      role="textbox"
      tabIndex={0}
      onKeyUp={() => {}}
    >
      <img
        className={cx(s.AddToHomeScreenImage, s.AddToHomeScreenImage_InstallApp)}
        src={imgSrc}
        alt=""
      />
      <div
        className={cx(s.AddToHomeScreenText, s.AddToHomeScreenText_InstallApp)}
      >
        {installAppText}
      </div>
      <div
        className={cx(s.AddToHomeScreenButton, s.AddToHomeScreenButton_InstallApp)}
      >
        Добавить
      </div>
      <button
        className={cx(s.AddToHomeScreenCloseButton, s.AddToHomeScreenCloseButton_InstallApp)}
        type="button"
        onClick={(ev) => {
          ev.stopPropagation();
          handleClose();
        }}
      >
        <XIcon />
      </button>
    </div>
  );
  const IOSModalEl = (
    <div
      className={cx(s.AddToHomeScreenWrap, s.AddToHomeScreenWrap_iOS)}
    >
      <img
        className={cx(s.AddToHomeScreenImage, s.AddToHomeScreenImage_iOS)}
        src={imgSrc}
        alt=""
      />
      <div
        className={cx(s.AddToHomeScreenText, s.AddToHomeScreenText_iOS)}
      >
        <div>{installAppText}</div>
        <div>
          Нажмите на
          <IOSMenuIcon />
          и выберите «На экран «Домой»
        </div>
      </div>
      <button
        className={cx(s.AddToHomeScreenCloseButton, s.AddToHomeScreenCloseButton_iOS)}
        type="button"
        onClick={handleClose}
      >
        <XIcon />
      </button>
    </div>
  );

  const modalEl = () => {
    if (canInstallApp) return installAppModalEl;
    if (isIOS) return IOSModalEl;
    return null;
  };

  if (show && portal) {
    return createPortal(modalEl(), portal);
  }

  return null;
}

export default AddToHomeScreen;
